if (!customElements.get('price-range')) {
  
  class PriceRange extends HTMLElement {
    constructor() {
      super();

      this.minInput = this.querySelector('.price-range__inputs__input--min');
      this.maxInput = this.querySelector('.price-range__inputs__input--max');

      this.bar = this.querySelector('.price-range__bar');
      this.activeBar = this.querySelector('.price-range__bar__active');

      this.minHandle = this.querySelector('.price-range__bar__price-control--min');
      this.maxHandle = this.querySelector('.price-range__bar__price-control--max');

      this.min = Number(this.minInput?.min || 0);
      this.max = Number(this.minInput?.max || 0);

      this.dragging = null;

      // Debounced filter application
      this.applyFiltersDebounced = (() => {
        let t;
        return () => {
          clearTimeout(t);
          t = setTimeout(() => {
            this.minInput.dispatchEvent(new Event('change', { bubbles: true }));
          }, 250);
        };
      })();
    }

    connectedCallback() {
      if (!this.minInput || !this.maxInput) return;

      this.syncFromInputs();
      this.bindEvents();
    }

    bindEvents() {
      // Slider dragging
      this.minHandle?.addEventListener('pointerdown', () => this.startDrag('min'));
      this.maxHandle?.addEventListener('pointerdown', () => this.startDrag('max'));

      window.addEventListener('pointermove', this.onDrag);
      window.addEventListener('pointerup', this.onPointerUp);

      // Typing into inputs
      this.minInput.addEventListener('input', () => {
        this.syncFromInputs();
        this.applyFiltersDebounced();
      });

      this.maxInput.addEventListener('input', () => {
        this.syncFromInputs();
        this.applyFiltersDebounced();
      });
    }

    startDrag(type) {
      this.dragging = type;
    }

    onPointerUp = () => {
      if (!this.dragging) return;

      this.dragging = null;

      // Apply filters once drag ends
      this.minInput.dispatchEvent(new Event('change', { bubbles: true }));
    };

    onDrag = (e) => {
      if (!this.dragging) return;

      const rect = this.bar.getBoundingClientRect();
      const percent = Math.min(
        1,
        Math.max(0, (e.clientX - rect.left) / rect.width)
      );

      const value = Math.round(this.min + percent * (this.max - this.min));

      if (this.dragging === 'min') {
        this.minInput.value = Math.min(
          value,
          Number(this.maxInput.value || this.max)
        );
      } else {
        this.maxInput.value = Math.max(
          value,
          Number(this.minInput.value || this.min)
        );
      }

      this.syncFromInputs();
    };

    syncFromInputs() {
      let minVal = Number(this.minInput.value || this.min);
      let maxVal = Number(this.maxInput.value || this.max);

      // Clamp values and prevent crossing
      minVal = Math.max(this.min, Math.min(minVal, maxVal));
      maxVal = Math.min(this.max, Math.max(maxVal, minVal));

      this.minInput.value = minVal || '';
      this.maxInput.value = maxVal || '';

      const minPercent = ((minVal - this.min) / (this.max - this.min)) * 100;
      const maxPercent = ((maxVal - this.min) / (this.max - this.min)) * 100;

      this.minHandle.style.left = `${minPercent}%`;
      this.maxHandle.style.left = `${maxPercent}%`;

      this.activeBar.style.left = `${minPercent}%`;
      this.activeBar.style.width = `${maxPercent - minPercent}%`;
    }
  }

  customElements.define('price-range', PriceRange);
}